import { EventActionType } from './event-action-type';

export interface LoadEventRequestAction {
  eventKey: string;
  type: EventActionType.LoadEventRequest;
}

export const loadEventRequest = (eventKey: string): LoadEventRequestAction => ({
  eventKey,
  type: EventActionType.LoadEventRequest,
});
